import { useTranslation } from "react-i18next";
import PolicyPageLayout, {
  PolicySection,
} from "../shared/components/PolicyPageLayout";

const HyperlinkPolicy = () => {
  const { t } = useTranslation("home");

  return (
    <PolicyPageLayout title={t("hyperlinkPolicy.title")}>
      <PolicySection title={t("hyperlinkPolicy.externalLinks.title")}>
        {t("hyperlinkPolicy.externalLinks.content")}
      </PolicySection>
      <PolicySection title={t("hyperlinkPolicy.inboundLinks.title")}>
        {t("hyperlinkPolicy.inboundLinks.content")}
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default HyperlinkPolicy;
